// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce72777e","455":"1f637177","977":"4bacb6a3"}[chunkId] + ".chunk.js";
};